var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 31.551,
    viewBox: "0 0 40 31.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-up-wide-short-duotone-solid",
    transform: "translate(-8.031 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M288,34.254A2.249,2.249,0,0,1,290.248,32h15.739a2.254,2.254,0,0,1,0,4.507H290.248A2.249,2.249,0,0,1,288,34.254Zm0,9.015a2.249,2.249,0,0,1,2.248-2.254h11.242a2.254,2.254,0,0,1,0,4.507H290.248A2.249,2.249,0,0,1,288,43.268Zm0,9.015a2.249,2.249,0,0,1,2.248-2.254h6.746a2.254,2.254,0,0,1,0,4.507h-6.746A2.249,2.249,0,0,1,288,52.283Zm0,9.015a2.249,2.249,0,0,1,2.248-2.254H292.5a2.254,2.254,0,0,1,0,4.507h-2.249A2.249,2.249,0,0,1,288,61.3Z",
    transform: "translate(-260.206)",
    fill: "#8b8996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M16.461,32a2.254,2.254,0,0,1,1.658.732L24.3,39.493a2.25,2.25,0,1,1-3.317,3.042L18.709,40.05V61.3a2.248,2.248,0,1,1-4.5,0V40.05l-2.277,2.486a2.25,2.25,0,1,1-3.317-3.042L14.8,32.732A2.254,2.254,0,0,1,16.461,32Z",
    transform: "translate(0)",
    fill: "#33ffc8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUp);
export default __webpack_public_path__ + "static/media/sort-up.06829377605893050bdea9d212ef63ef.svg";
export { ForwardRef as ReactComponent };